import { Box, Button, Card, Container, Stack } from '@mui/material';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import Page from 'src/components/page/page';
import { useLPProducts } from './products-lp-list.hook';
import BenefitApprovalTabs from 'src/components/benefit-approval-tabs/benefit-approval-tabs';
import DataGridCustom from 'src/components/data-grid-custom';
import LpProductTableFilter from './components/lp-product-table-filter/lp-product-table-filter';
import { paths } from 'src/routes/paths';

export default function LPProducts() {
  const {
    tabValue,
    benefits,
    sortModel,
    paginationModel,
    search,
    headers,
    isLoading,
    initialVisibleColumns,
    roles,
    setPaginationModel,
    setSortModel,
    navigate,
    onChangeTab,
    setSearch,
    setAppliedFilters,
  } = useLPProducts();

  return (
    <Page title='Homologação de Produtos'>
      <Container maxWidth='xl'>
        <HeaderBreadcrumbs
          heading='Homologação de Produtos'
          links={[]}
        />
        <Stack direction='row' justifyContent='space-between' alignItems='center'>
          <BenefitApprovalTabs onChangeTab={onChangeTab} value={tabValue} />
          {
            roles?.some((role) =>
              ['lp_shopkeeper', 'lp_exhibitor', 'lp_contractor'].includes(role)
            ) &&
            <Button variant='contained' onClick={() => navigate(paths.dashboard.lpProductCreate)}>
              Cadastrar Produto
            </Button>
          }
        </Stack>
        <Box height={24} />
        <Card sx={{ p: 2 }}>
          <DataGridCustom
            columns={headers}
            rows={benefits?.data ? benefits?.data?.map((b: any) => ({ ...b, id: b._id })) : []}
            customFilters={
              <LpProductTableFilter
                searchText={search}
                setAppliedFilters={setAppliedFilters}
                setSearchText={setSearch}
              />
            }
            filteredRowsCount={benefits?.total || 0}
            totalRowsCount={benefits?.total || 0}
            initialVisibleColumns={initialVisibleColumns}
            onRowClick={({ row }) => navigate(paths.dashboard.lpProductDetails(row.id))}
            sortModel={sortModel}
            setSortModel={setSortModel}
            paginationModel={paginationModel}
            setPaginationModel={setPaginationModel}
            isLoading={isLoading.value}
            height={400}
          />
        </Card>
      </Container>
    </Page >
  );
}
